export const getColumnHeaderHeight = (rowHeight: number) => {
  const HEADER_HEIGHT_ADDITION = 12;

  return rowHeight + HEADER_HEIGHT_ADDITION;
};
